export const EVENT_DEADLOCK_ENTER_GAME = "EVENT_DEADLOCK_ENTER_GAME";
export const EVENT_DEADLOCK_EXIT_GAME = "EVENT_DEADLOCK_EXIT_GAME";
export const EVENT_DEADLOCK_HEARTBEAT = "EVENT_DEADLOCK_HEARTBEAT";
export const EVENT_DEADLOCK_METADATA = "EVENT_DEADLOCK_METADATA";
